<div class="message-card">
  <div class="success-icon">
    <img ngSrc="/utest-static/assets/images/registration/warning.svg" alt="" height="40" width="40"/>
  </div>

  <h1 class="title">Your Email Address Was Already Verified</h1>

  <div class="message-body">
    <p>No further action is needed, we’re redirecting you to our <a href="/login" class="login-link">login page</a>. Visit our tester support <a href="http://support.utest.com/csp" class="help-link" target="_blank">support.utest.com</a> for account assistance.</p>
  </div>

  <div class="help-section">
    <p class="help-text">
      Having issues or need help? Contact us at
      <a href="http://support.utest.com/csp" class="help-link" target="_blank">support.utest.com</a>
    </p>
  </div>
</div>
